import { parseIntWithNAFallback, parseIntWithNVFallback } from 'sources/parsers/commons';

export const parseGsc = rawData =>
    rawData.map(item => ({
        keyword: item.keys[0],
        serpPosition: parseIntWithNAFallback(item.position),
        searchCount: parseIntWithNVFallback(item.sv || 0),
    }));
